<script>
	import listBase from '@_system/components/base/list.vue'
	import DepartmentTree from '@_system/components/formcomponents/common/select/department/tree.vue'
	import Detail from './lib/detail.vue'
	export default {
		extends: listBase,
		name: 'departmentIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
					<div style="position: relative;">
						<el-button size="mini" type="primary" onClick={this.addlist}>添加</el-button>
						<el-button size="mini" type="success" onClick={this.editlist}>编辑</el-button>
						<el-button size="mini" type="danger" onClick={this.dellist}>删除</el-button>
						<el-switch style="margin-left:10px" v-model={this.status} active-text="显示离职" active-value={4} inactive-value={3}></el-switch>
					</div>
			]
			this.$slots.aside = [
				<Department-tree ref="DepartmentTree" key={this.DepartmentTreeKey} onSelect={this.departmentTreeChange} />
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>{window.config.title}</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			this.$slots.plug = [
				<vxe-modal v-model={this.detailShow} width="1200" height="600" title={this.detailTitle} destroy-on-close show-footer size="mini">
					<Detail staffid={this.staffid} />
				</vxe-modal>,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				asideWidth:400,
				componenttype: 'system',
				moduleName: 'staff',
				windowName: '部门人员',
				departmentid: 0,
				departmentname: '',
				parentbread: [],
				DepartmentTreeKey: Math.random(),
				DepartmentTreeRef: Math.random(),
				detailTitle: '详情',
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				},
				detailShow: false,
				status: 3
			}
		},
		watch: {
			status(){
				this.customreload()
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			detail(row) {
				this.staffid = row.id
				this.detailTitle = '详情：' + row.name
				this.detailShow = true
			},
			resetpassword(row) {
				this.$confirm(row.name + ' 是否重置密码?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.staff.resetpassword(row.id).then(()=>{
						this.$message.success('操作成功')
					})
				}).catch(() => {
        
				});	
			},
			departmentTreeChange(e) {
				let departmentidbread = []
				e.parentbread.forEach((item) => {
					departmentidbread.push(item.id)
				})
				this.departmentid = e.id
				this.departmentidbread = departmentidbread
				this.departmentname = e.name
				this.parentbread = e.parentbread
				if (this.departmentid) {
					this.gridOptions.pagerConfig = {
						currentPage: 1,
						pageSize: 20,
					}
					this.customreload()
				}

				//this.customreload()
			},
			beforeRequest(form) {
				form.status = this.status
				if (this.departmentid != 0) {
					form.departmentid = this.departmentid
				}
			},

			beforeCreateGrid(formConfig, columns,gridOptions) {
				gridOptions.height = 650
				columns.unshift({
					field: "managedepartment",
					title: "主管部门",
					minWidth: 100
				})
				columns.forEach((item) => {
					if (item.field == 'managedepartment') {
						item.slots = {
							default: ({
								row
							}) => {
								let node = []
								row.managedepartment.forEach((item) => {
									node.push(
										<el-tag style = "margin-right:4px" size = "mini" effect = "dark" type = "danger" >{item}</el-tag>
									)
								})
								return node

							}
						}
					}
				})
				// options.pagerConfig = {
				// 	layouts: [],
				// 	currentPage: 1,
				// 	pageSize: 999,
				// }
			},
			addlist() {
				import('@_system/components/forms/organization/department/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'department',
						id: 0,
						controlltype: 1,
						show: true
					}
				})
			},
			editlist() {
				if (this.departmentid != 0) {
					import('@_system/components/forms/organization/department/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'department',
							id: this.departmentid,
							controlltype: 2,
							show: true
						}
					})
				} else {
					this.$message.error({
						message: '请选择部门',
					})
				}
			},
			add() {
				import('@_system/components/forms/organization/staff/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'staff',
						id: 0,
						controlltype: 1,
						show: true,
						extra: {
							defaultvalue: {
								department: this.departmentidbread
							},
						}
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/organization/staff/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'staff',
						id: row.id,
						controlltype: 2,
						show: true,
					}
				})
			},
			del(row) {
				this.$confirm('是否删除 ' + row.name, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.staff.delete(row.id).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})
			},
			dellist() {
				if (this.departmentid != 0) {
					this.$confirm('是否删除 ' + this.departmentname, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.department.delete(this.departmentid).then(() => {
							this.$message({
								message: '操作成功',
								type: 'success'
							})
							this.reloadlist()
						})
					}).catch(() => {

					})
				} else {
					this.$message.error({
						message: '请选择部门',
					})
				}
			},
			formBack(e) {
				let component = this.formModule.component
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}

				if (e.type != 'cancle') {
					if (component.name == 'staffForm') {
						this.customreload()
					} else {
						this.reloadlist()
					}
				}

			},
			reloadlist() {
				window.systemData.department = null
				this.departmentid = []
				this.departmentname = ''
				this.parentbread = []
				this.DepartmentTreeKey = Math.random()	
			}
		},
		components: {
			DepartmentTree,
			Detail,

		}
	}
</script>
